export const FETCH_ALL_GROUPS = "FETCH_ALL_GROUPS";
export const FETCH_ALL_GROUPS_SUCCESS = "FETCH_ALL_GROUPS_SUCCESS";
export const FETCH_ALL_GROUPS_ERROR = "FETCH_ALL_GROUPS_ERROR";
export const FETCH_ALL_GROUPS_START = "FETCH_ALL_GROUPS_START"

export const fetchAllGroups = () => {
    return {
        type: FETCH_ALL_GROUPS
    };
};